import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface CustomSubOptionItem {
    value: string;
    label: string;
    count?: number;
}

interface Props {
    selected: string;
    onChange: (option: string) => void;
    customItems?: CustomSubOptionItem[];
}

function SubOptions(props: Props) {
    const [t] = useTranslation();
    const items = useMemo(
        () =>
            (props.customItems?.length
                ? props.customItems
                : [{ value: "", label: t("options.hazard") }]).filter(
                (item) => !!item.value
            ),
        [props.customItems, t]
    );

    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            value={props.selected}
            onChange={(_, v) => { if (v !== null) props.onChange(v); }}
            sx={{
                gap: "10px",
                "& .MuiToggleButtonGroup-grouped": {
                    border: "none",
                    borderRadius: "20px !important",
                    padding: "0 20px",
                    minWidth: "120px",
                    height: "40px",
                    lineHeight: "40px",
                    backgroundColor: "#ededed",
                    color: "#333",
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "none",
                },
                "& .MuiToggleButtonGroup-grouped.Mui-selected": {
                    backgroundColor: "#0e8a3f14",
                    color: "var(--green)",
                },
                "& .MuiToggleButtonGroup-grouped.Mui-selected:hover": {
                    color: "var(--green)",
                },
                "& .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
                    border: "none",
                    borderRadius: "20px !important",
                    marginLeft: 0,
                },
            }}
        >
            {items.map((item) => (
                <ToggleButton key={item.value} value={item.value}>
                    {item.label}{item.count ? `(${item.count})` : ""}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}

export default SubOptions;
